class Dot {
    constructor(gridY, gridZ, origin, originSub, speed) {
        this.gridX = 0;
        this.gridY = gridY;
        this.gridZ = gridZ;
        this.x = Math.random() - 0.5;
        this.y = Math.random() - 0.5;
        this.z = Math.random() - 0.5;
        this.dx = (Math.random() - 0.5) / 100 * speed;
        this.dy = (Math.random() - 0.5) / 100 * speed;
        this.dz = (Math.random() - 0.5) / 100 * speed;
        this.pointX = null;
        this.pointY = null;
        this.pointZ = null;
        this.projectedX = null;
        this.projectedY = null;
        this.projectedZ = null;
        this.origin = origin;
        this.originSub = originSub;
    }
}

export default Dot;